/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COLOR SCHEME - SENTIMENT CONFIGS : STYLES --------------- ++++++++++ */
export default {
    colorscheme: {
        display: 'flex',
        marginBottom: pxToEm(16)
    }
};
